import styled from '@emotion/styled';
import {useId} from 'react';

type Props = {
  from: string;
  to: string;
  className?: string;
};

export const Background = styled(({from, to, className}: Props) => {
  const b = useId();
  const c = useId();
  const d = useId();
  const f = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 930 110"
      className={className}
    >
      <g clipPath="url(#a)">
        <rect width="930" height="110" fill={`url(#${b})`} rx="5" />
        <path
          fill={`url(#${c})`}
          d="M345-11H-50v298h696c-8-24-47-31-57-35-9-4-80-27-80-66 0-23-2-49-17-74-12-19-66-37-90-40-28-3-80-16-68-41s12-38 11-42Z"
        />
        <path
          fill={`url(#${d})`}
          d="M142-30h-332v306h666c-7-21-62-46-87-53-21-6-73-15-87-55-10-28 19-119-61-136-99-20-96-48-99-62Z"
        />
        <g filter="url(#e)">
          <path
            fill={`url(#${f})`}
            d="m1002 203 162-94-177-307L661-10c15 19 57 29 73 29 14 0 45-5 75 30 21 26 59 125 108 119 60-8 75 21 85 35Z"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id={b}
          x1="465"
          x2="465"
          y1="0"
          y2="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={to} />
          <stop offset=".4" stopColor={from} />
        </linearGradient>
        <linearGradient
          id={c}
          x1="298"
          x2="298"
          y1="-11"
          y2="287"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={to} />
          <stop offset=".4" stopColor={from} />
        </linearGradient>
        <linearGradient
          id={d}
          x1="143"
          x2="143"
          y1="-30"
          y2="276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={to} />
          <stop offset=".4" stopColor={from} />
        </linearGradient>
        <linearGradient
          id={f}
          x1="1001.2"
          x2="824.2"
          y1="202.8"
          y2="-103.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={to} />
          <stop offset=".4" stopColor={from} />
        </linearGradient>
        <clipPath id="a">
          <rect width="930" height="110" fill="#fff" rx="5" />
        </clipPath>
        <filter
          id="e"
          width="503.4"
          height="404.5"
          x="661"
          y="-198"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="shape" result="effect1_innerShadow_130_78758" />
        </filter>
      </defs>
    </svg>
  );
})`
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  min-width: 100%;
`;
